export default function (value, n = 0) { //eslint-disable-line
  return parseFloat(Math.round(value * Math.pow(10, n)) / Math.pow(10, n)).toFixed(n);  //eslint-disable-line
}



// WEBPACK FOOTER //
// ./src/js/filters/digits.js